export const mapConfig = {
  zoom: 3,
  lng: -71.542969,
  lat: -35.675147,
  minZoom: 3.5,
};
